import { useQuery } from '@tanstack/react-query'
import useMutationWithInvalidation from 'api/react-query/hooks/useMutationWithInvalidation'
import { deleteTextProcessor, getAllTextProcessors, patchTextProcessor } from './endpoints'
import type { TextProcessorPatternPatch } from './types'

const TEXT_PROCESSOR_KEY = ['TEXT_PROCESSOR']

export const useGetAllTextProcessors = () =>
  useQuery({
    queryKey: TEXT_PROCESSOR_KEY,
    queryFn: () => getAllTextProcessors(),
  })

export const usePatchTextProcessor = () => {
  return useMutationWithInvalidation(
    { queryKey: ['TEXT_PROCESSOR_PATCH'] },
    (patch: TextProcessorPatternPatch) => patchTextProcessor(patch.id, patch),
    TEXT_PROCESSOR_KEY,
  )
}

export const useDeleteTextProcessor = () => {
  return useMutationWithInvalidation({ queryKey: ['TEXT_PROCESSOR_DELETE'] }, (id: string) => deleteTextProcessor(id), TEXT_PROCESSOR_KEY)
}
